import React from 'react';

const Tenping = () => {
  return (
    <div className="box_blog box_blog_type2">
      <div className="wrap_logo">
        <img src="//t1.daumcdn.net/tistory_admin/static/manage/images/temp/tenping.png"
             alt="Tenping" className="company_logo" width="100"/>
      </div>
      <div className="wrap_cont">
        <strong className="screen_out">특징</strong>
        <ul className="list_cont ">
          <li><span className="ico_blog ico_check_type3"/><span className="txt_g">다양한 소문 타입의 콘텐츠</span>
          </li>
          <li><span className="ico_blog ico_check_type3"/><span className="txt_g">자유자재로 붙일 수 있는 '소문박스' 기능</span>
          </li>
          <li><span className="ico_blog ico_check_type3"/><span className="txt_g">수익 및 효율 정보를 앱·웹으로 확인 가능</span>
          </li>
        </ul>
      </div>
      <span className="btn_type5 btn_type5_type1">준비 중</span>
    </div>
  )
};

export default Tenping;